// ------------------------------------------------------------------
// MissingValue — story 2-137 (P10 §2, content grammar).
// ------------------------------------------------------------------
//
// THE GAP. "An explicit missing-value rendering" is one of this story's own
// content rules, and at HEAD it had no single answer: an absent address
// rendered as an empty string, a blank cell, `'N/A'` in one place and `'—'`
// in another, none of them announced to assistive tech as anything other
// than silence. This is the ONE glyph + ONE accessible name for "this field
// has no value" — a value-presentation primitive smaller than `DataList`
// (owned by story 2-138, P10 §2.4), which will COMPOSE this rather than
// growing its own second missing-value convention.
//
// Deliberately an em dash, not the word "None"/"N/A": those read as an
// answer ("the value IS none"), where an em dash reads as a placeholder — a
// blank that was never filled in, not a value that was recorded as absent.
// `aria-label` carries the honest "<field> not provided" (or the generic
// fallback) so a screen-reader user hears the same distinction a sighted
// user sees.

export const MISSING_VALUE_GLYPH = '—'; // —

export interface MissingValueProps {
  /** The field this value is missing FROM, e.g. "Due date" — folded into
   * the accessible name ("Due date not provided") so a list of several
   * missing values doesn't announce as an indistinguishable string of dashes. */
  label?: string;
  className?: string;
}

export function MissingValue({ label, className = '' }: MissingValueProps): JSX.Element {
  return (
    <span
      className={`text-muted-foreground ${className}`}
      aria-label={label ? `${label} not provided` : 'Not provided'}
    >
      {MISSING_VALUE_GLYPH}
    </span>
  );
}
